<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'category-create',
				},

				languages: null,
				statuses: null,
				categories: [],

				category: null,

				item: {
					title: null,
					slug: null,
					category_id: null,
					status_id: null,
				},

				lang_id: null,

				loading: false,
				slug_in_use: false,
			}
		},
		mounted() {
			var modal = $('#'+this.modal.selector)
			var that = this
			modal.on('hidden.bs.modal', function () {
				that.clearData()
			})
		},
		watch: {
			category() {
				if(this.category) {
					this.item.category_id = this.category.id
				} else {
					this.item.category_id = null
				}
			},
			lang_id() {
				this.getCategories()
			},
			'item.title'() {
				this.item.slug = this.$options.filters.slugify(this.item.title)
			},
			'item.slug'() {
				this.checkSlug()
			},
		},
		methods: {
			open() {
				this.clearData()
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getStatuses()
				this.getLanguages()
			},
			clearData() {
				this.item.title = null
				this.item.slug = null
				this.item.category_id = null
				this.lang_id = null
				this.item.status_id = 2
				this.slug_in_use = false
				this.loadDefaultLanguage()
				this.errors.clear()
			},
			getStatuses: function() {
				this.statuses = null
				this.$http.get('admin/statuses')
					.then(response => {
						this.statuses = response.body
						this.item.status_id = 2
					})
			},
			getLanguages: function() {
				this.languages = null
				this.$http.get('languages')
					.then(response => {
						this.languages = response.body
						this.loadDefaultLanguage()
					})
			},
			loadDefaultLanguage() {
				if(this.languages) {
					if(this.languages.length) {
						var locale = this.$lang.getLang()
						var lang = this.languages.find(function(language) {
							return language.lang_code == locale
						})
						if(lang) {
							this.lang_id = lang.id
						}
					}
				}
				this.getCategories()
			},
			getCategories() {
				this.categories = []
				this.category = null
				var data = {
					lang_id: this.lang_id,
					id: this.item.category_id,
				}
				this.$http.post('admin/cms/categories/get', data)
					.then(response => {
						this.categories = response.body
					})
			},
			slugInUse(slug_in_use) {
				this.slug_in_use = slug_in_use
			},
			changeLoading(loading) {
				this.loading = loading
			},
			validate() {
				var that = this
				if(this.loading) {
					return false
				}
				if(this.slug_in_use) {
					return false
				}
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.checkSlug(true)
					}
					if(that.$validator.errors.items.length) {
						that.$el.querySelector('[name=' + that.$validator.errors.items[0].field + ']').focus()
					}
					return result
				})
			},
			store () {
				if(!this.loading) {
					if(!this.slug_in_use) {
						var btnStore = Ladda.create(this.$refs.btnStore)
						btnStore.start()
						this.$http.post('admin/cms/articles', this.item)
							.then(response => {
								this.close()
								this.$emit('reload')
								btnStore.stop()
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
								this.editOrContinue(response)
							}).catch(function(response) {
								console.log(response)
								this.$emit('reload')
								btnStore.stop()
								if(response.status == 409) {
									swal({
										title: response.body.title,
										text: response.body.text,
										type: response.body.type,
									})
								}
							})
					}
				}
			},
			editOrContinue(response) {
				var article = response.body.data
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + "/admin/cms/articles/" + article.id + '/edit')
				}).catch(swal.noop)
			},
			checkSlug(store = false) {
				this.loading = true
				if(this.item.slug) {
					var data = {
						id: this.item.id,
						slug: this.item.slug,
						category_id: this.item.category_id,
					}
					this.$http.post('admin/cms/articles/check/slug', data)
						.then(response => {
							var in_use = response.body
							this.slug_in_use = in_use > 0
							this.loading = false
							if(store) {
								this.store()
							}
						})
				} else {
					this.loading = false
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/cms/articles/views/Create.vue